import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const header = css`
  block-size: unset;
  margin-block-end: ${spacing(0.75)};
`
